
export default class contentFixes
{
    constructor()
    {
        if ($('.hero-wrapper').find('.no-blocks').length) {
            $('.hero-wrapper').css('min-height', '0px');
        }

        // /faculty-staff/faculty-staff-directory form search fix
        // if this needs to be debugged, navigate to ae css styles.css and comment out '.faculty-staff-search-form .ccm-block-express-entry-list-advanced-search-fields {display: none !important;}' <-- this
        if ( $('.search-form-js').length ) {
            $('.search-form-js .form-control').attr('placeholder', 'i.e.: John Smith');

            $('.search-form-js .search-icon-js').click(function () {
                $(this).prev().focus();
            });

            $('.options-js').each( function () { // $('.options-js') --> old options
                var sectionName = $(this).prev().text();

                $(this).children().each( function () {
                    var checked = $(this).children().children().attr('checked') == 'checked' ? true : false;
                    $(this).children().children().attr('checked', false); // if we don't set this to false/unchecked, then everything remains checked and you eventually end up with everything selected without the ability to deselect anything

                    var optionName  = $(this).children().children().attr('name');
                    var optionText  = $(this).children().text();
                    var optionValue = $(this).children().children().attr('value');

                    if ( sectionName.indexOf('Department(s)') === 0 ) {
                        this._appendValue(checked, $('.department-js'), optionName, optionValue, optionText);
                    } else if ( sectionName.indexOf('Faculty/Staff') === 0 ) {
                        this._appendValue(checked, $('.staff-js'), optionName, optionValue, optionText);
                    } else if ( sectionName.indexOf('Site') === 0 ) {
                        this._appendValue(checked, $('.sites-js'), optionName, optionValue, optionText);
                    }
                });
            });
        }

        if ($('.table-header-green-js').length) {
            $('.table-header-green-js').parents('th').addClass('table-header-green');
        }
    }

    _appendValue ( checked, element, optionName, optionValue, optionText )
    {
        element.attr('name', optionName);

        if ( checked ) {
            element.append('<option value="' + optionValue + '" selected>' + optionText + '</option>');
        } else {
            element.append('<option value="' + optionValue + '">' + optionText + '</option>');
        }
    }
}
